export default __webpack_public_path__ + "static/media/Link.1a93b883.svg";